export const TV_SHOWS = {
    BASE_URL: "/tv-shows"
}

export const RANDOM = {
    BASE_URL: "/random"
}